import { FC, useEffect, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useCampaignsActions } from '../context';
import { CreateCampaignFormInput, CreateCampaignFormOutput } from '../validation';
import { CampaignSummaryItem, CampaignSummaryItemField } from './CampaignSummaryItem';
import { CampaignStepSummaryProps } from './CampaignSummarySection';

export const SelectAudienceStepSummary: FC<CampaignStepSummaryProps> = ({ isStepCompleted }) => {
  const { t } = useTranslation();

  const { setStep } = useCampaignsActions();
  const { control, setValue } = useFormContext<CreateCampaignFormInput, unknown, CreateCampaignFormOutput>();

  const audience = useWatch({
    control,
    name: 'audience',
  });

  useEffect(() => {
    if (audience) {
      setValue('audience', { ...audience });
    }
  }, [audience?.id, setValue]);

  const renderLabel = () => {
    switch (audience?.scheduleType) {
      case 'REALTIME':
        return t('ALL:realtimeUpdate');

      case 'MANUAL':
        return t('ALL:manualUpdate');

      case 'SCHEDULED':
        return t('ALL:scheduledUpdate');

      default:
        return undefined;
    }
  };

  const content = useMemo<CampaignSummaryItemField[]>(() => {
    if (!audience) return [];

    return [{ field: t('COMMON:name'), value: audience.name }];
  }, [audience]);

  return (
    <CampaignSummaryItem
      index={4}
      title={t('ALL:selectAudienceSummary')}
      content={content}
      label={renderLabel()}
      {...(isStepCompleted && { onClick: () => setStep('SelectAudience') })}
    />
  );
};
